import { PART_CATALOG_CHANGES_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/part_catalog_changes_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['partCataloghangeIndex']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
